import { render, staticRenderFns } from "./ResetConfirm.vue?vue&type=template&id=91002cfa&scoped=true&"
import script from "./ResetConfirm.vue?vue&type=script&lang=js&"
export * from "./ResetConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ResetConfirm.vue?vue&type=style&index=0&id=91002cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91002cfa",
  null
  
)

export default component.exports